// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3hHL2","text":"SelectPayment_text__64bua","title":"SelectPayment_title__3XA7x","btn":"SelectPayment_btn__iPzoB"};